import React, { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../../utils/Api";

function ResetPasswordConfirm() {
  const [params] = useSearchParams();
  const token = params.get("token");

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setMessage("Las contraseñas no coinciden.");
      setMessageType("error");
      return;
    }

    try {
      const response = await api.post("/reset-password/confirm", {
        token,
        password,
        password_confirmation: confirm,
      });
      setMessage(response.data.message);
      setMessageType("success");
      setPassword("");
      setConfirm("");
    } catch (error) {
      console.error(error);
      setMessage(error.response?.data?.message || "Error al cambiar la contraseña.");
      setMessageType("error");
    }
  };

  return (
    <div className="container-md w-50 mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6 bg-white p-4 rounded shadow text-center">
          <h1 className="mb-3 fs-2">Restablecer Contraseña</h1>
          <p>Introduce tu nueva contraseña para tu cuenta.</p>

          <form onSubmit={handleSubmit} className="mt-4">
            <div className="mb-3 text-start">
              <label className="form-label">Nueva Contraseña:</label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="mb-3 text-start">
              <label className="form-label">Confirmar Contraseña:</label>
              <input
                type="password"
                className="form-control"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="btn w-100"
              style={{ background: "#FF7A00", color: "#fff", border: "none" }}
            >
              Guardar Contraseña
            </button>
          </form>

          {message && (
            <div
              className={`mt-3 ${
                messageType === "success" ? "text-success" : "text-danger"
              }`}
            >
              {message}
            </div>
          )}

          <div className="mt-3">
            <Link to="/" style={{ color: "#FF7A00", textDecoration: "none" }}>
              Volver al inicio de sesión
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordConfirm;
